export default __webpack_public_path__ + "static/media/dial-pad.2732ee11.png";